module.exports = __webpack_public_path__ + "img/ac65594.png";